"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ImageStatic = _interopRequireDefault(require("ol/source/ImageStatic"));

var _Polygon = _interopRequireDefault(require("ol/geom/Polygon"));

var _Image = _interopRequireDefault(require("ol/layer/Image"));

var _createLayer = _interopRequireDefault(require("./createLayer"));

var _constants = require("./constants");

var _propTypes = require("prop-types");

var _proj = require("ol/proj");

var ImageLayer = (0, _createLayer["default"])({
  displayName: 'ImageLayer',
  propTypes: {
    bounds: _propTypes.array.isRequired,
    crossOrigin: _propTypes.string,
    loadFunction: _propTypes.func,
    projection: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]),
    size: _propTypes.array,
    url: _propTypes.string.isRequired
  },
  // Reproject extent from LatLon to Web Mercator
  reprojectExtent: function reprojectExtent(extent) {
    return (0, _proj.transformExtent)(extent, _constants.GEO_PROJECTION, _constants.WEB_PROJECTION);
  },
  // Reproject the bounds' geometry
  reprojectGeometry: function reprojectGeometry(geometry, projection) {
    return geometry.clone().transform(_constants.GEO_PROJECTION, projection);
  },
  getExtentFromBounds: function getExtentFromBounds(bounds, projection) {
    // Create a polygon from the bounds
    var geometry = new _Polygon["default"](bounds);
    var extent;

    if (projection) {
      // Reproject the geometry and get the extent
      // (Resulting extent will be in projection)
      extent = this.reprojectGeometry(geometry, projection).getExtent();
    } else {
      // Reproject the extent to Web Mercator for map
      extent = this.reprojectExtent(geometry.getExtent());
    }

    return extent;
  },
  componentDidMount: function componentDidMount() {
    // Create the image source
    var source = new _ImageStatic["default"]({
      url: this.props.url,
      imageExtent: this.getExtentFromBounds(this.props.bounds, this.props.projection),
      imageSize: this.props.size,
      projection: this.props.projection || _constants.WEB_PROJECTION,
      imageLoadFunction: this.props.loadFunction,
      crossOrigin: this.props.crossOrigin
    }); // Create the image layer

    this.layer = new _Image["default"]({
      source: source,
      visible: this.props.visible
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      var source = this.layer.getSource();
      source.clear();

      if (this.props.url) {
        var newSource = new _ImageStatic["default"]({
          url: this.props.url,
          imageExtent: this.getExtentFromBounds(this.props.bounds, this.props.projection),
          imageSize: this.props.size,
          projection: this.props.projection || _constants.WEB_PROJECTION,
          imageLoadFunction: this.props.loadFunction,
          crossOrigin: this.props.crossOrigin
        });
        this.layer.setSource = newSource;
      } else {
        source.clear();
      }
    }
  }
});
var _default = ImageLayer;
exports["default"] = _default;